// extracted by mini-css-extract-plugin
export var option = "_2u-0";
export var optionSelected = "_2u-1 _2u-0";
export var optionUnselected = "_2u-2 _2u-0";
export var radioInner = "_2u-5";
export var radioOuter = "_2u-3";
export var radioOuterSelected = "_2u-4 _2u-3";